import { gql } from 'graphql-tag'

export const GET_NOTIFICATION_PREFERENCE = gql`
  query getNotificationPreference($consumerId: ID!) {
    notificationPreference: getNotificationPreference(consumerId: $consumerId) {
      channel
    }
  }
`
